(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelEdicaoRecomendacao', PainelEdicaoRecomendacao);

  function PainelEdicaoRecomendacao() {
    return {
      restrict: 'E',
      templateUrl: 'views/painel_propriedade/recomendacao/_edicao.html',
      controller: 'RecomendacaoCtrl'
    };
  }

}());
